module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/superadmin/hospitals/hospitals.component.scss
// module id = ./src/app/modules/superadmin/hospitals/hospitals.component.scss
// module chunks = main